export default function RequiredIndicator() {
	return <span className="text-rural-red-900 inline-block" aria-label="Required"><span className="pdf-hide">*</span></span>;
}
